var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUserPlaceholder = function SvgUserPlaceholder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3264FF",
    d: "M75.3 62c-.5-.3-1-.6-1.5-.8-1.1-.5-2.3-.9-3.8-1.4-6.6-2.1-13.6-3.2-20.5-3.1-8.3-.1-16.6 1.4-24.3 4.5-1.6.7-3 1.8-4 3.2-.2.2-.3.5-.5.7-1.1 1.9-1.7 4.1-1.7 6.2C19 72.9 28.9 88 49.5 88s30.6-15.1 30.6-16.6c0-1-.2-2.1-.4-3-.7-2.6-2.2-4.9-4.4-6.4M49.6 50.9c8 0 14.4-6.5 14.4-14.4v-3.8c0-8-6.5-14.4-14.4-14.4-8 0-14.4 6.5-14.4 14.4v3.8c0 8 6.4 14.4 14.4 14.4",
    className: "userPlaceholder_svg__st0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUserPlaceholder);
export default ForwardRef;